import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCk24VImgG5KogR6pJHeNzobUB_By9HbsY",
  projectId: "ntcv1-245hhk",
  storageBucket: "ntcv1-245hhk.appspot.com",
  messagingSenderId: "897158933383",
  authDomain: "ntcv1-245hhk.firebaseapp.com",
  // appId and measurementId are optional when not using Analytics or certain other Firebase services
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db }; 